import React, { useEffect, useState } from "react"
import { Link } from "gatsby"
import $ from "jquery"

import FormRegisterCompany from "./forms/formRegisterCompany"
import FormRegisterCustomer from "./forms/formRegisterCustomer"
import FormRegisterDealer from "./forms/formRegisterDealer"

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [modal, setModal] = useState(false)

  const [modalRegisterCustomer, setModalRegisterCustomer] = useState(false)
  const [
    modalRegisterTransportCompany,
    setModalRegisterTransportCompany,
  ] = useState(false)
  const [modalRegisterCarDealer, setModalRegisterCarDealer] = useState(false)

  const resetModal = () => {
    setModal(false)
    setModalRegisterCustomer(false)
    setModalRegisterTransportCompany(false)
    setModalRegisterCarDealer(false)
  }

  useEffect(() => {
    $(window).scroll(function () {
      var scroll = $(window).scrollTop()
      if (scroll >= 1) {
        $("header").addClass("shrink")
      } else {
        $("header").removeClass("shrink")
      }
    })
  })

  if (typeof window !== "undefined") {
    if (isMenuOpen === true) {
      document.body.classList.add("appleFix")
    } else {
      document.body.classList.remove("appleFix")
    }
  }

  return (
    <>
      {/* eslint-disable jsx-a11y/control-has-associated-label */}
      <header className="header">
        <div className="container-fluid">
          <div className="header__wrapper">
            <div className="header__wrapper-inner">
              <Link to="/" className="header__brand">
                <img src={require("../assets/images/logo.svg")} alt="" />
              </Link>
              <div className={`header__nav${isMenuOpen ? " is-open" : ""}`}>
                <Link
                  to="/transport-company/"
                  className="btn-custom btn-custom--small btn-custom--blue"
                  activeClassName="btn-custom--blue--active"
                >
                  Transport Company
                </Link>
                <Link
                  to="/customer/"
                  className="btn-custom btn-custom--small btn-custom--blue"
                  activeClassName="btn-custom--blue--active"
                >
                  Customer
                </Link>
                <Link
                  to="/car-dealer/"
                  className="btn-custom btn-custom--small btn-custom--blue"
                  activeClassName="btn-custom--blue--active"
                >
                  Car Dealer
                </Link>
              </div>
            </div>
            <div className="header__actions">
              <button
                onClick={e => setModal(true)}
                className="btn-custom btn-custom--small btn-custom--green"
              >
                Register
              </button>
            </div>
          </div>
        </div>
        <button
          type="button"
          aria-label="Open Menu"
          className={`hamburger hamburger--squeeze ${
            isMenuOpen ? "is-active" : ""
          }`}
          onClick={e => setIsMenuOpen(!isMenuOpen)}
        >
          {Array(4)
            .fill(null)
            .map((item, index) => (
              <span key={index} />
            ))}
        </button>
      </header>
      {modal && (
        <>
          <div className="custom-modal">
            {modalRegisterCustomer === true ? (
              <FormRegisterCustomer />
            ) : modalRegisterTransportCompany === true ? (
              <FormRegisterCompany />
            ) : modalRegisterCarDealer === true ? (
              <FormRegisterDealer />
            ) : (
              <>
                <h3>Continue as</h3>
                <div className="row justify-content-center">
                  <div className="col-sm-4">
                    <button
                      onClick={e => setModalRegisterCustomer(true)}
                      className="tile"
                    >
                      <div className="tile__thumb">
                        <img
                          src={require("../assets/images/ico-customer.svg")}
                          alt=""
                        />
                      </div>
                      <p>Customer</p>
                    </button>
                  </div>
                  <div className="col-sm-4">
                    <button
                      onClick={e => setModalRegisterTransportCompany(true)}
                      className="tile"
                    >
                      <div className="tile__thumb">
                        <img
                          src={require("../assets/images/ico-transport-company.svg")}
                          alt=""
                        />
                      </div>
                      <p>
                        Transport <br /> Company
                      </p>
                    </button>
                  </div>
                  <div className="col-sm-4">
                    <button
                      onClick={e => setModalRegisterCarDealer(true)}
                      className="tile"
                    >
                      <div className="tile__thumb">
                        <img
                          src={require("../assets/images/ico-car-dealer.svg")}
                          alt=""
                        />
                      </div>
                      <p>
                        Car <br /> Dealer
                      </p>
                    </button>
                  </div>
                </div>
              </>
            )}
            <button
              className="custom-modal__close"
              onClick={resetModal}
            ></button>
          </div>
          <button
            className="custom-modal__overlay"
            onClick={resetModal}
          ></button>
        </>
      )}
    </>
  )
}

export default Header
